import Command from '@ckeditor/ckeditor5-core/src/command';
import { isCustomButtonElement } from '../utils';

export default class CustomButtonAlignmentCommand extends Command {
	override refresh() {
		const element = this.editor.model.document.selection.getSelectedElement()!;

		this.isEnabled = isCustomButtonElement( element );

		if ( isCustomButtonElement( element ) && element.hasAttribute( 'float' ) ) {
			this.value = element.getAttribute( 'float' );
		} else {
			this.value = false;
		}
	}

	override execute( options : {value: string} ) {
		const model = this.editor.model;
		const customButtonElement = model.document.selection.getSelectedElement()!;
		this.value = options.value;

		model.change( writer => {
			writer.setAttribute( 'float', options.value, customButtonElement );
		} );
	}
}

